import(/* webpackMode: "eager" */ "/app/src/app/service/defend/layout.tsx");
